export default (() => {
    let existingTable = document.getElementById('tableResults');
      
    if (!existingTable) {
        existingTable = document.createElement('table');
        existingTable.id = 'tableResults';
        
        let thead = existingTable.createTHead();
        let headerRow = thead.insertRow();
        let headerData = ['Pin', 'Property Address', 'Owner', 'Owner Address', ''];
        
        for (var headerText of headerData) {
            var th = document.createElement('th');
            th.appendChild(document.createTextNode(headerText));
            headerRow.appendChild(th);
        }
    }
    return existingTable;
})